import { globalFetch } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        fundraiseCreationCompleteShowReceipt: false,
        isFundraiseImageUploading: false,
        personalStoryImagesUploading: 0,
        personalDonationShowReceipt: false,
        fundraiseCreationEventId: null,
        donation_settings: {
            donationId: undefined,
            linkToInformationHowDonationBenefits: undefined,
            single: {
                presets: [],
                defaultPreset: undefined
            },
            recurring: {
                presets: [],
                defaultPreset: undefined
            }
        },
        isSubmitting: false,
        isEditing: true,
        isFundraiseImageUploadError: false,
        isPersonalStoryImageUploadError: false,
        personalFundraisingFlowStep: null,
        userProfileFundraisingCampaigns: []
    },
    mutations: {
        completeFundraiseCreation(state) {
            state.fundraiseCreationCompleteShowReceipt = true
        },
        completePersonalDonation(state) {
            state.personalDonationShowReceipt = true
        },
        set_fundraiseCreationEventId(state, eventId) {
            state.fundraiseCreationEventId = eventId
        },
        set_donation_settings(state, settings) {
            state.donation_settings = settings
        },
        set_submitting(state, isSubmitting) {
            state.isSubmitting = isSubmitting
        },
        set_fundraise_image_uploading(state, isUploading) {
            state.isFundraiseImageUploading = isUploading
        },
        add_personal_story_image_uploading(state) {
            state.personalStoryImagesUploading += 1
        },
        remove_personal_story_image_uploading(state) {
            state.personalStoryImagesUploading -= 1
        },
        set_fundraise_image_upload_error(state, data) {
            state.isFundraiseImageUploadError = data
        },
        set_personal_story_image_upload_error(state, data) {
            state.isPersonalStoryImageUploadError = data
        },
        set_editing(state, isEditing) {
            state.isEditing = isEditing
        },
        set_user_profile_fundraising_campaigns(state, data) {
            state.userProfileFundraisingCampaigns = data
        },
        set_personal_fundraising_flow_step(state, step) {
            state.personalFundraisingFlowStep = step
        }
    },
    actions: {
        getUserProfileFundraisingCampaigns(context, userProfileId) {
            const url = `${document.location.origin}/${process.env.GET_USERPROFILE_FUNDRAISING_CAMPAIGNS.replace('[userProfileId]', userProfileId)}`
            globalFetch(url)
                .then((response) => response.json())
                .then((data) => {
                    const campaigns = Array.isArray(data)
                        ? data.filter(campaign => campaign.name && campaign.url)
                        : []
                    context.commit('set_user_profile_fundraising_campaigns', campaigns)
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        setEditing(context, isEditing) {
            context.commit('set_editing', isEditing)
        },
        discardUploadedImage(context, payload) {
            const url = process.env.DISCARDFUNDRAISEIMAGE
            const method = process.env.FETCHMETHOD

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = { headers, method, body: JSON.stringify(payload) }

            if (method !== 'POST') delete init.body // leave this in

            return globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    throw 'File deletion failed'
                })
                .catch((err) =>
                    console.error(
                        'Der skete en fejl med sletning af billedet',
                        err
                    )
                )
        },
        uploadFundraiseImage(context, payload) {
            const url = `${document.location.origin}/${process.env.UPLOAD_FUNDRAISEIMAGES.replace('[id]', payload.id)}`
            const method = process.env.POSTMETHOD

            const data = new FormData()
            data.append('imageFile', payload.file)

            //Explicitly excluded 'Content-Type' to allow the browser to
            //calculate the 'multipart/form-data' boundary
            const headers = new Headers()
            const init = { headers, method, body: data }

            if (method !== 'POST') delete init.body // leave this in

            if (payload.type == 'fundraiseImage')
                context.commit('set_fundraise_image_uploading', true)
            if (payload.type == 'personalStoryImage')
                context.commit('add_personal_story_image_uploading')

            return globalFetch(url, init)
                .then((response) => {
                    if (response.ok) {
                        return response.json()
                    }
                    throw ('Response not ok', response)
                })
                .catch((err) => {
                    console.error('Der skete en fejl med dit billedupload', err)
                    if (payload.type == 'fundraiseImage')
                        context.commit('set_fundraise_image_upload_error', true)
                    if (payload.type == 'personalStoryImage')
                        context.commit(
                            'set_personal_story_image_upload_error',
                            true
                        )
                })
                .finally(() => {
                    if (payload.type == 'fundraiseImage')
                        context.commit('set_fundraise_image_uploading', false)
                    if (payload.type == 'personalStoryImage')
                        context.commit('remove_personal_story_image_uploading')
                })
        },
        createPersonalfundraising(context, payload) {
            const url = `${document.location.origin}/${process.env.CREATE_PERSONALFUNDRAISING.replace('[id]', payload.id)}`
            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method,
                body: JSON.stringify(payload.content)
            }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_submitting', true)
            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit('completeFundraiseCreation')
                    context.commit('set_editing', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    console.error('Der skete en fejl med din indsamling', err)
                })
                .finally(() => {
                    context.commit('set_submitting', false)
                })
        },
        updatePersonalfundraising(context, { id, content }) {
            const url = `${document.location.origin}/${process.env.UPDATE_PERSONALFUNDRAISING.replace('[id]', id)}`
            const method = process.env.PUTMETHOD

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = { headers, method, body: JSON.stringify(content) }

            if (method !== 'PUT') delete init.body // leave this in

            context.commit('set_submitting', true)
            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    context.commit('set_submitting', false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit('completeFundraiseCreation')
                    context.commit('set_editing', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    context.commit('set_submitting', false)
                    console.error('Der skete en fejl med din indsamling', err)
                })
        },
        deletePersonalfundraising(context, payload) {
            const url =
                `${document.location.origin}/${process.env.DELETE_PERSONALFUNDRAISING.replace('[id]', payload.id)}` +
                '?pageId=' +
                payload.pageId
            const method = process.env.DELETEMETHOD

            const headers = new Headers()
            const init = { headers, method }

            context.commit('set_submitting', true)
            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    context.commit('set_submitting', false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    context.commit('set_editing', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    context.commit('set_submitting', false)
                    console.error('Der skete en fejl med din indsamling', err)
                })
        },
        // FF1 Støt os
        submitPersonalDonation(context, payload) {
            const url = `${document.location.origin}/${process.env.SUBMIT_DONATION}`
                .replace('[pageId]', payload.pageId)
            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = { headers, method, body: JSON.stringify(payload) }

            if (method !== 'POST') delete init.body // leave this in

            const isPbs = payload.paymentMethod == '4'

            context.commit('set_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    context.commit('set_submitting', false)
                    throw new Error(response.error)
                })
                .then((json) => {
                    if (isPbs) {
                        context.commit('set_editing', false)
                        context.commit('completePersonalDonation')
                    } else {
                        context.commit('set_editing', false)
                        document.location.href = json.paymentUrl
                    }
                })
                .catch((err) => {
                    context.commit('set_submitting', false)
                    console.error('Der skete desværre en fejl med din donation', err)
                })
        },
        // FF3 Donation til digitale indsamlinger
        submitPersonalDonation2(context, { fundraisingCampaignId, payload }) {
            let url = `${document.location.origin}/${process.env.SUBMIT_PERSONAL_DONATION}`
            url = url.replace('[guid]', fundraisingCampaignId)

            const method = process.env.POSTMETHOD

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = { headers, method, body: JSON.stringify(payload) }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_submitting', true)
            globalFetch(url, init)
                .then((response) => {
                    if (!response.ok) {
                        context.commit('set_submitting', false)
                        console.log(response.error)
                        return
                    }
                    console.log(response)
                    return response.json()
                })
                .then((json) => {
                    context.commit('set_editing', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    context.commit('set_submitting', false)
                    console.error('Der skete en fejl med din donation', err)
                })
        },
        showReceipt(context, payload) {
            context.commit('completePersonalDonation')
        }
    },
    getters: {}
}
